export default "__VITE_ASSET__DBje9EV4__"